<div [id]="model.name" (click)="onItemClick()" (dblclick)="onItemDoubleClick()" style="user-select: none;" data-cy="tree-item-container">
  <div cdkDropList (cdkDropListDropped)="onItemDrop($event)" [id]="model.id"
       (cdkDropListExited)="onItemExited($event)"
       (cdkDropListEntered)="onItemEntered($event, model)"
       data-cy="tree-item-drop-zone">
    <ng-container
      [ngTemplateOutlet]="template"
      [ngTemplateOutletContext]="{ $implicit: model, isDragEnter: isDragEnter}"
      data-cy="tree-item-content">
    </ng-container>
  </div>
  <!--<ng-template #noKids>
    <ng-container
      [ngTemplateOutlet]="template"
      [ngTemplateOutletContext]="{ $implicit: model, isDragEnter: isDragEnter}"
    ></ng-container>
  </ng-template>-->
</div>
<div *ngFor="let mod of model.children"  style="margin-left: 10px;" [ngClass]="{'tdo-tree-item-expanded': model.isExpanded, 'tdo-tree-item-collapsed': !model.isExpanded}" data-cy="tree-item-children">
  <app-tdo-tree-item (itemDropped)="onItemDropped($event)" (itemSelected)="onItemSelected($event)" [model]="mod" [template]="template" data-cy="tree-item-child"></app-tdo-tree-item>
</div>
